import React, { memo, useRef } from "react";
import {
  DatePickerInput,
  DropDown,
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
  TextareaField,
  TimePickerInput,
} from "../../../../components";
import styles from "./editBusinessInfo.module.css";
import Upload from "../../../../assets/upload.png";
import { Col, Row, Switch, TimePicker } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { roles } from "../../../../config/roles";
import { CalendarIcon, ClockIcon } from "../../../../components/icons/Icons";
import Modal from "../../../../components/modal/Modal";
import moment from "moment/moment";
import { CgCheckO } from "react-icons/cg";
import { MdOutlineRadioButtonUnchecked } from "react-icons/md";
import AvailablityModal from "./AvailabilityModal/AvailablityModal";
import { useDispatch, useSelector } from "react-redux";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import addDoc from "../../../../assets/staticImages/addDoc.png";
import addImg from "../../../../assets/staticImages/addImg.png";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { RiDeleteBinLine } from "react-icons/ri";

// const RenderDoc = memo(({ docs, i }) => {
//   return (
//     <DocViewer
//       // documents={docs}
//       documents={[{ uri : "http://192.168.0.162/BestEverDay/public/storage/uploads/vendorprofile_documents/1709038720_sample.pdf"}]}
//       pluginRenderers={DocViewerRenderers}
//       className={styles.pdfView}
//       activeDocument={docs}
//       config={{
//         header: { disableHeader: true },
//         pdfVerticalScrollByDefault: false,
//       }}
//       initialActiveDocument={docs}
//       language="en"
//     />
//   );
// });

// const RenderDocView = memo(({ docs, setDocs, i, doc }) => {
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   function handleDropdown(e) {
//     e.stopPropagation();
//     setDropdownOpen((prev) => !prev);
//   }
//   const deleteDoc = (i) => {
//     let docObjCpy = [...docs];
//     docObjCpy?.splice(i,1)
//     setDocs(docObjCpy)
//   };

//   return (
//     <Col className={styles.pdfCol} key={i.toString()}>
//       <Row style={{ justifyContent: "flex-end" }}>
//         <TextComponent textClass={styles.dropdownBtn} onClick={handleDropdown}>
//           ...
//         </TextComponent>
//       </Row>
//       {dropdownOpen && (
//         <Row className={styles.dropdown}>
//           <Col>
//             <Row
//               className={styles.dropdownItem}
//               onClick={() => deleteDoc(i)}
//             >
//               <RiDeleteBinLine fontSize="1.1rem" />
//               <TextComponent textClass={styles.dropdownText}>
//                 Delete
//               </TextComponent>
//             </Row>
//           </Col>
//         </Row>
//       )}
//       <RenderDoc docs={doc} i={i} />
//     </Col>
//   );
// });
// const RenderImg = memo(({ imgs, i }) => {
//   return (
//     <DocViewer
//       documents={[imgs]}
//       pluginRenderers={DocViewerRenderers}
//       className={styles.pdfView}
//       activeDocument={imgs}
//       config={{
//         header: { disableHeader: true },
//         pdfVerticalScrollByDefault: false,
//       }}
//       initialActiveDocument={imgs}
//       language="en"
//     />
//   );
// });

// const RenderImgView = memo(({ imgs, setimgs, i, img }) => {
//   // console.log("imgs");
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   function handleDropdown(e) {
//     e.stopPropagation();
//     setDropdownOpen((prev) => !prev);
//   }
//   const deleteImg = (i) => {
//     let imgObjCpy = [...imgs];
//     imgObjCpy?.splice(i,1)
//     setimgs(imgObjCpy)
//   };

//   return (
//     <Col className={styles.pdfCol} key={i.toString()}>
//       <Row style={{ justifyContent: "flex-end" }}>
//         <TextComponent textClass={styles.dropdownBtn} onClick={handleDropdown}>
//           ...
//         </TextComponent>
//       </Row>
//       {dropdownOpen && (
//         <Row className={styles.dropdown}>
//           <Col>
//             <Row
//               className={styles.dropdownItem}
//               onClick={() => deleteImg(i)}
//             >
//               <RiDeleteBinLine fontSize="1.1rem" />
//               <TextComponent textClass={styles.dropdownText}>
//                 Delete
//               </TextComponent>
//             </Row>
//           </Col>
//         </Row>
//       )}
//       <RenderImg imgs={img} i={i} />
//     </Col>
//   );
// });
const EditProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const types = useSelector((state) => state.GeneralReducer.GeneralTypes);
  const user = useSelector((state) => state.AuthReducer.user);
  // const categoryOptions = [...types?.servicecategory];
  const [companyName, setCompanyName] = useState(
    user?.business_info?.company_name ? user?.business_info?.company_name : ""
  );
  const [price, setPrice] = useState(
    user?.business_info?.service_price ? user?.business_info?.service_price : ""
  );
  const [contact, setcontact] = useState(
    user?.business_info?.company_contact_no
      ? user?.business_info?.company_contact_no
      : ""
  );
  const [service, setSevice] = useState(
    user?.business_info?.service_category_id
      ? { id: user?.business_info?.service_category_id }
      : ""
  );
  const [serveDay, setServeDay] = useState(user?.availability);
  const [serviceDetails, setServiceDetails] = useState(
    user?.business_info?.service_offer ? user?.business_info?.service_offer : ""
  );
  const [description, setDescription] = useState(
    user?.business_info?.description ? user?.business_info?.description : ""
  );
  const [startTime, setStartTime] = useState(
    user?.business_info?.start_time
      ? moment(user?.business_info?.start_time).format("hh:mm A")
      : null
  );
  const [endTime, setEndTime] = useState(
    user?.business_info?.end_time
      ? moment(user?.business_info?.end_time).format("hh:mm A")
      : null
  );
  const [isAvailablityModalOpen, setIsAvailablityModalOpen] = useState(false);
  const [timeModal, setTimeModal] = useState(false);
  // const [docs, setDocs] = useState([...user?.documents]);
  // const [imgs, setimgs] = useState([...user?.photos]);
  let format =
    user?.business_info?.end_time && user?.business_info?.start_time
      ? moment(user?.business_info?.start_time).format("hh:mm A") +
        " - " +
        moment(user?.business_info?.end_time).format("hh:mm A")
      : "--";

  console.log(user?.availability);

  // const docRef = useRef();
  // const imgRef = useRef();

  // const handleClick = () => {
  //   docRef.current.value = "";
  //   docRef.current.click();
  // };
  // const handleClickImg = () => {
  //   imgRef.current.value = "";
  //   imgRef.current.click();
  // };
  // console.log("docsdocsdocsdocsdocs", docs);
  // console.log("imgsimgsimgsimgsimgsimgs", imgs);
  // const onSelectCategory = (category) => {
  //   if (service.includes(category)) {
  //     setSevice(service.filter((item) => item != category));
  //   } else {
  //     setSevice([...service, category]);
  //   }
  // };

  let order = [
    { id: 2, day: "Mon" },
    { id: 3, day: "Tue" },
    { id: 4, day: "Wed" },
    { id: 5, day: "Thu" },
    { id: 6, day: "Fri" },
    { id: 7, day: "Sat" },
    { id: 1, day: "Sun" },
  ];
  const onSelectDay = (day) => {
    // console.log(day);

    const isSelected = serveDay?.find((item) => item?.day == day?.day);
    if (isSelected) {
      setServeDay(serveDay.filter((item) => item.day != day.day));
    } else {
      let avail = [...serveDay, day];

      console.log("avail", avail);
      let days = order?.filter((data) =>
        avail?.find((item) => item.day == data.day)
      );

      console.log("days", days);
      setServeDay(days);
    }
  };

  const onPressSave = () => {
    navigate(-1);
  };
  const updateBusiness = () => {
    if (
      !companyName ||
      !contact ||
      !description ||
      !price ||
      !service?.id ||
      !serviceDetails ||
      !serveDay.length > 0 ||
      !startTime ||
      !endTime
    ) {
      dispatch(
        showAlert({
          title: "updateBusiness",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
    } else {
      let userdata = {
        comp_name: companyName,
        comp_contact_no: contact,
        description: description,
        service_price: price,
        service_category: service?.id,
        service_offer: serviceDetails,
        start_time: startTime
          ? moment(startTime?.time?.$d).format("HH:mm")
          : null,
        end_time: endTime ? moment(endTime?.time?.$d).format("HH:mm") : null,
        availablity: serveDay,
        schedule_type: "Weekly",
        messageHide: true,
      };

      dispatch(AuthMiddleware.updateVendorProfile(userdata))
        .then(() => navigate(-1))
        .catch();
    }
  };

  return (
    <div className={styles.main_box}>
      <TextComponent
        text={"Business Information"}
        textClass={styles.texthead}
      />
      <Row>
        <Col className={styles.sub_div}>
          <InputField
            label={"Company Name"}
            placeholder="Photopia"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            // labelClass={styles.label}
            // styles={styles.input}
          />
          <PhoneInput
            style={{ marginBottom: "20px", backgroundColor: "white" }}
            className={styles.phoneInput}
            value={contact}
            onChange={setcontact}
            label={"Company Contact Number"}
          />
          <TextareaField
            label={"Description"}
            placeholder="Add Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <TextComponent text="Office Hours" textClass={styles.lable} />
          <TextComponent
            // text={`${moment(startTime?.time?.$d).format("hh:mm A")} to ${moment(
            //   endTime?.time?.$d
            // ).format("hh:mm A")}`}
            text={
              startTime && endTime
                ? `${moment(startTime?.time?.$d).format("hh:mm A")} to ${moment(
                    endTime?.time?.$d
                  ).format("hh:mm A")}`
                : format
            }
            textClass={styles.textAvail}
          />
          <Row className={styles.dayRow}>
            <Col className={styles.addDays}>
              {serveDay?.length > 0 ? (
                <>
                  {serveDay.map((day, i) => (
                    <TextComponent
                      textClass={styles.dayText}
                      text={`${day?.day} ${
                        i < serveDay.length - 1 ? ", " : ""
                      }`}
                    />
                  ))}
                </>
              ) : (
                <TextComponent textClass={styles.dayText} text={"--"} />
              )}
            </Col>
            <Col>
              <CalendarIcon
                size={30}
                className={styles.CalIcon}
                onClick={() => setIsAvailablityModalOpen(true)}
              />
            </Col>
          </Row>
        </Col>

        <Col className={styles.sub_divx}>
          <InputField
            label={"Starting Price"}
            placeholder="$100"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            type="number"
          />
          <TextareaField
            value={serviceDetails}
            onChange={(e) => setServiceDetails(e.target.value)}
            label={"Service Offer"}
            placeholder="Services you offer"
          />
          <TextComponent text="Service Category" textClass={styles.lable} />
          <Row>
            {types?.servicecategory?.map((serviceName, i) => (
              <Col
                className={`${
                  service?.id == serviceName?.id
                    ? styles.activeCategory
                    : styles.categoryCont
                }`}
                // onClick={() => onSelectCategory(serviceName)}
                onClick={() => setSevice(serviceName)}
              >
                <TextComponent text={`${serviceName?.name}`} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
      {/* <Row>
            {docs.map((doc, i) => {
              return (
                <>
                  <RenderDocView
                    key={i.toString()}
                    docs={docs}
                    doc={doc}
                    i={i}
                    setDocs={setDocs}
                  />
                </>
              );
            })}
          </Row>
          <Row>
            <Col className={styles.imgCol} onClick={handleClick}>
              <img src={addDoc} className={styles.image} alt="docSelect" />
              <input
                type="file"
                accept=".pdf"
                multiple
                onChange={(el) =>
                  el.target.files?.length &&
                  setDocs([
                    ...docs,
                    ...Array.from(el.target.files).map((file, i) => ({
                      doc: file,
                      uri: window.URL.createObjectURL(file),
                      media_type: "application",
                      fileName: file.name,
                      // id: `${docs?.length + i + 12}`,
                    })),
                  ])
                }
                ref={docRef}
                className={styles.displayNone}
              />
            </Col>
          </Row>
          <Row>
            {imgs.map((img, i) => {
              return (
                <>
                  <RenderImgView
                    key={i.toString()}
                    imgs={imgs}
                    img={img}
                    i={i}
                    setimgs={setimgs}
                  />
                </>
              );
            })}
          </Row>
          <Row>
          <Col className={styles.imgCol} onClick={handleClickImg}>
              <img src={addImg} className={styles.image} alt="docSelect" />
              <input
                type="file"
                accept=".jpg,.png,.gif,.jpeg"
                multiple
                onChange={(el) =>
                  el.target.files?.length &&
                  setimgs([
                    ...imgs,
                    ...Array.from(el.target.files).map(
                      (file, i) => (
                        console.log("file.name", file),
                        {
                          image: file,
                          uri: window.URL.createObjectURL(file),
                          media_type: "image",
                          fileName: file.name,
                          // id: `${imgs.length + i + 12}`,
                        }
                      )
                    ),
                  ])
                }
                ref={imgRef}
                className={styles.displayNone}
              />
            </Col>
            </Row> */}
      <SubmitButton
        title={"Save"}
        onClick={updateBusiness}
        btnClass={styles.button}
      />
      {isAvailablityModalOpen && (
        <AvailablityModal
          isAvailablityModalOpen={isAvailablityModalOpen}
          setIsAvailablityModalOpen={setIsAvailablityModalOpen}
          startTime={startTime}
          setStartTime={setStartTime}
          endTime={endTime}
          setEndTime={setEndTime}
          serveDay={serveDay}
          onSelectDay={onSelectDay}
        />
      )}
    </div>
  );
};

export default EditProfile;
